module.exports = __webpack_public_path__ + "img/c1.84ae9572.jpg";